var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { formatCurrency } from "@irati/utils/currency/formatCurrency";
import { injectIntl } from "@irati/utils/lang";
import authentication from "@irati/auth";
import { TopUpConfirmationPopup } from "../WalletPopups";
var CardConfirmationPopUp = /** @class */ (function (_super) {
    __extends(CardConfirmationPopUp, _super);
    function CardConfirmationPopUp() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CardConfirmationPopUp.prototype.render = function () {
        var _a = this.props, formatMessage = _a.formatMessage, tenantWalletTopup = _a.tenantWalletTopup, showCompletionModal = _a.showCompletionModal, goBackToTransactions = _a.goBackToTransactions;
        var tenantName = authentication.userTenant().public_name;
        var userEmail = authentication.user().email;
        var firstRow = {
            label: formatMessage({ id: "wallet.tenant.topUp.cardPopUp.amountPurchased" }),
            value: formatCurrency({
                currencyCode: authentication.defaultUserCurrency(),
                value: tenantWalletTopup.amount,
                isCents: true,
                trimZerosFromWholeNumber: false
            })
        };
        var secondRow = {
            label: formatMessage({ id: "wallet.tenant.topUp.cardPopUp.order" }),
            value: tenantWalletTopup.uuid
        };
        return (React.createElement(TopUpConfirmationPopup, { title: formatMessage({ id: "wallet.tenant.topUp.cardPopUp.header" }), mainMessage: formatMessage({ id: "wallet.tenant.topUp.cardPopUp.mainMessage" }, { tenantName: tenantName }), invoiceToMessage: formatMessage({ id: "wallet.tenant.topUp.invoicePopUp.invoiceTo" }, { userEmail: userEmail }), firstRow: firstRow, secondRow: secondRow, details: tenantWalletTopup, onClose: goBackToTransactions, show: showCompletionModal }));
    };
    return CardConfirmationPopUp;
}(PureComponent));
export default injectIntl(CardConfirmationPopUp);
